module.exports = __webpack_public_path__ + "img/bg02.efad71a8.png";